
















































































































































































































































































































































import UnitModel, {
  ApiKeyModel,
  IPAddressModel,
  ManageFeaturesModel
} from '@/_models/UnitModel'
import { Component, Vue } from 'vue-property-decorator'
import TablePagination from '@/components/shared/TablePagination.vue'
import { mapGetters } from 'vuex'

@Component({
  components: { TablePagination },
  computed: {
    ...mapGetters('units', {
      canEdit: 'canEdit'
    }),
    ...mapGetters('units', {
      canDelete: 'canDelete'
    })
  }
})
export default class Information extends Vue {
  // data
  public apiKeys: any = []
  public ipWhitelist: IPAddressModel[] = []
  public canEdit!: boolean
  public canDelete!: boolean
  public uploadFile: any = null

  public ipListFilters = {
    currentPage: 1,
    perPage: 10,
    searchQuery: '',
    numofPage: 0
  }

  get selected(): UnitModel {
    const item = this.$store.state.units.item as UnitModel
    if (!item?.api_keys) {
      item.api_keys = []
    }

    if (!item?.ip_whitelist) {
      item.ip_whitelist = []
    }

    if (item?.manage_features === undefined) {
      item.manage_features = new ManageFeaturesModel()
    }

    if (item?.manage_features?.link === undefined) {
      item.manage_features.link = false
    }

    this.apiKeys = item?.api_keys
    this.ipWhitelist = item?.ip_whitelist
    this.ipListFilters.numofPage = item?.ip_whitelist?.length

    return item
  }

  get apiKeyAccessRightOptions(): any {
    return [
      {
        code: 1,
        label: 'option.api_key_access_right.owner'
      },
      {
        code: 2,
        label: 'option.api_key_access_right.admin'
      },
      {
        code: 3,
        label: 'option.api_key_access_right.viewer'
      }
    ]
  }

  get manageFeaturesList(): any {
    const selectedFeatures = this.selected.manage_features

    return [
      {
        label: 'stamp_rally',
        status: selectedFeatures?.stamp_rally || false
      },
      {
        label: 'work_recorder',
        status: selectedFeatures?.work_recorder || false
      },
      {
        label: 'indoor_map',
        status: selectedFeatures.hasOwnProperty('indoor_map')
          ? selectedFeatures.indoor_map
          : true
      },
      {
        label: 'outdoor_map',
        status: selectedFeatures.hasOwnProperty('outdoor_map')
          ? selectedFeatures.outdoor_map
          : true
      },
      {
        label: 'ip_camera',
        status: selectedFeatures?.ip_camera || false
      },
      {
        label: 'geofence',
        status: selectedFeatures?.geofence || false
      },
      {
        label: 'link',
        status: selectedFeatures?.link || false
      }
    ]
  }

  get IpListFiltered(): IPAddressModel[] {
    return this.ipWhitelist.filter((item: IPAddressModel) => {
      const searchKey =
        String(item.ip_address)
          .toLowerCase()
          .indexOf(this.ipListFilters.searchQuery.toString().toLowerCase()) !==
          -1 || item.ip_address === ''

      return searchKey
    })
  }

  // Handle methods
  public handleAddDomain(index: number): void {
    this.selected.domains.splice(index + 1, 0, '')
  }

  public handleDeleteDomain(index: number): void {
    this.selected.domains.splice(index, 1)
  }

  public handleAddApiKey(index: number): void {
    this.apiKeys.splice(index + 1, 0, new ApiKeyModel())
  }

  public handleAddIPAddress(index: number): void {
    // this.ipListFilters.searchQuery = ''
    this.ipWhitelist.splice(index + 1, 0, new IPAddressModel())
  }

  public handleDeleteIPAddress(index: number): void {
    this.ipWhitelist.splice(index, 1)
  }

  public handleDeleteApiKey(index: number): void {
    this.apiKeys.splice(index, 1)
  }

  public async handleApplyChange(): Promise<void> {
    if (this.uploadFile) {
      this.$store.dispatch('units/uploadFile', this.uploadFile).then(resp => {
        this.selected.logo = resp.file_url_org
        this.doApplyChange()
      })
    } else {
      this.doApplyChange()
    }
  }

  public async doApplyChange(): Promise<void> {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return false
      }

      this.selected.api_keys = this.apiKeys
      this.selected.ip_whitelist = this.ipWhitelist

      this.manageFeaturesList.forEach(manageFeature => {
        this.selected.manage_features[manageFeature.label] =
          manageFeature.status
      })

      this.$store.dispatch('units/updateOne', this.selected).then(resp => {
        this.$buefy.toast.open(this.$t('messages.update_success') as string)
      })
    })
  }

  public handleConfirmCustomDelete(): void {
    this.$buefy.dialog.confirm({
      title: this.$t('delete') as string,
      message: this.$t('messages.are_you_sure_want_to_delete') as string,
      confirmText: this.$t('delete') as string,
      cancelText: this.$t('button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        this.$store.dispatch('units/hasRefs', this.selected).then(result => {
          if (result.has_reference) {
            this.confirmForceDelete()
          } else {
            this.processDelete()
          }
        })
      }
    })
  }

  // Methods
  public isSupperUnit(item: UnitModel): boolean {
    return item.db_name === 'socan_api'
  }

  public confirmForceDelete(): void {
    this.$buefy.dialog.confirm({
      title: this.$t('delete') as string,
      message: this.$t(
        'messages.has_refs_data_are_you_sure_want_to_delete'
      ) as string,
      confirmText: this.$t('delete') as string,
      cancelText: this.$t('button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        this.processDelete()
      }
    })
  }

  public processDelete(): void {
    this.$store.dispatch('units/deleteOne', this.selected).then(() => {
      this.$router.push({ name: 'unit' })
      this.$buefy.toast.open(this.$t('messages.delete_success') as string)
    })
  }
}
